export const PinnedProjects = [
  {
    id: 1,
    category: "WEB Development",
    title: "Restrorder",
    image:
      "https://images.unsplash.com/photo-1547658719-da2b51169166?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=764&q=80",
    description:
      "Site to be used in restaurant by users to order their dishes from menu, generate invoice. Admin login to view and serve orders.",
    techs: "Reactjs, MongoDB, Expressjs, Nodejs, CSS, Bootstrap, Razorpay",
    code: "https://github.com/imneerajkumar/RestrOrder",
    demo: "",
  },
  {
    id: 2,
    category: "APP Development",
    title: "LetsPost",
    image:
      "https://images.unsplash.com/photo-1547658719-da2b51169166?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=764&q=80",
    description:
      "Users can post their photos with captions and other users can comment on them. Made for both Web and mobile application.",
    techs: "React-Native, Expo, Firebase, Redux",
    code: "https://github.com/imneerajkumar/letspost",
    demo: "",
  },
  {
    id: 3,
    category: "WEB Development",
    title: "Edule - eLearning Platform",
    image:
      "https://images.unsplash.com/photo-1547658719-da2b51169166?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=764&q=80",
    description:
      "E-Learning Platform with blogs, courses, live meetings and recorded lectures. Instructor dashboard also included.",
    techs:
      "Reactjs, MongoDB, Expressjs, Nodejs, Firebase, Redux, CSS, Bootstrap, jitsimeet",
    code: "https://github.com/imneerajkumar/edtech",
    demo: "",
  },
];

export const AllProjects = [
  {
    id: 1,
    category: "WEB Development",
    title: "Restrorder",
    image:
      "https://images.unsplash.com/photo-1547658719-da2b51169166?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=764&q=80",
    description:
      "Site to be used in restaurant by users to order their dishes from menu, generate invoice. Admin login to view and serve orders.",
    techs: "Reactjs, MongoDB, Expressjs, Nodejs, CSS, Bootstrap, Razorpay",
    code: "https://github.com/imneerajkumar/RestrOrder",
    demo: "",
  },
  {
    id: 2,
    category: "APP Development",
    title: "LetsPost",
    image:
      "https://images.unsplash.com/photo-1547658719-da2b51169166?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=764&q=80",
    description:
      "Users can post their photos with captions and other users can comment on them. Cross platform mobile application.",
    techs: "React-Native, Expo, Firebase, Redux",
    code: "https://github.com/imneerajkumar/letspost",
    demo: "",
  },
  {
    id: 3,
    category: "WEB Development",
    title: "Edule - eLearning Platform",
    image:
      "https://images.unsplash.com/photo-1547658719-da2b51169166?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=764&q=80",
    description:
      "E-Learning Platform with blogs, courses, live meetings and recorded lectures. Instructor dashboard also included.",
    techs:
      "Reactjs, MongoDB, Expressjs, Nodejs, Firebase, Redux, CSS, Bootstrap, jitsimeet",
    code: "https://github.com/imneerajkumar/edtech",
    demo: "",
  },
  {
    id: 4,
    category: "WEB Development",
    title: "Keeper",
    image:
      "https://images.unsplash.com/photo-1547658719-da2b51169166?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=764&q=80",
    description:
      "Users can login with google and can add, update, delete and download their notes.",
    techs: "Reactjs, Firebase, Google-Auth, CSS",
    code: "https://github.com/imneerajkumar/Keeper",
    demo: "",
  },
  {
    id: 5,
    category: "APP Development",
    title: "ShopApp",
    image:
      "https://images.unsplash.com/photo-1547658719-da2b51169166?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=764&q=80",
    description:
      "Its an e-commerce mobile application where users can view, add products to cart and order. Users can also list their own products for sale.",
    techs: "React-Native, Expo, Firebase, Redux",
    code: "https://expo.dev/@imneerajkumar/ShopApp",
    demo: "",
  },
  {
    id: 6,
    category: "WEB Development",
    title: "MyDocs",
    image:
      "https://images.unsplash.com/photo-1547658719-da2b51169166?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=764&q=80",
    description:
      "Multiple users can work on a single document simultaneously..",
    techs: "Reactjs, MongoDB, Nodejs, Socket.io, Quill",
    code: "https://github.com/imneerajkumar/my-docs",
    demo: "",
  },
];
